import React from 'react';
import { Modal, Button } from 'antd';
import { EditRecord } from './HolidaysTypes';

interface DeleteConfirmationLoaderModalProps {
  open: boolean;
  handleCloseDelete: () => void;
  handleSingleSelectDelete: (record: EditRecord) => void;
  selectedRows: EditRecord[];
  deleteMessage: string;
  loader: boolean;
}

const DeleteConfirmationLoaderModal = (props: DeleteConfirmationLoaderModalProps) => {
  const { open, handleCloseDelete, handleSingleSelectDelete, selectedRows, deleteMessage, loader } = props;

  return (
    <Modal
      title="Delete Confirmation"
      centered
      open={open}
      footer={null}
      maskClosable={!loader}
      keyboard={!loader}
      closable={!loader}
      onCancel={handleCloseDelete}
    >
      <div className='pt-4 text-[16px]'>{deleteMessage}</div>
      <div className='mt-8 flex justify-end gap-4'>
        <button
          className='addButton cancel-leave w-32'
          disabled={loader}
          onClick={handleCloseDelete}
        >
          Cancel
        </button>
        <Button
          type="primary"
          className="addButton w-32 "
          loading={loader}
          onClick={() => handleSingleSelectDelete(selectedRows[0])}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationLoaderModal;
